import { api } from "./client";

export type FunctionalTestKind =
  | "ecg"
  | "xray_chest"
  | "ultrasound"
  | "spirography"
  | "audiometry";

export interface FunctionalTestRead {
  id: string;
  examination_id: string;
  kind: FunctionalTestKind;
  summary_text: string | null;
  attachment_object_keys: string[];
  uploaded_by_user_id: string;
  uploaded_at: string;
}

export async function uploadFunctionalTest(
  examId: string,
  payload: {
    kind: FunctionalTestKind;
    summary_text: string;
    files: File[];
  },
): Promise<FunctionalTestRead> {
  const form = new FormData();
  form.append("kind", payload.kind);
  form.append("summary_text", payload.summary_text);
  payload.files.forEach((f) => form.append("files", f));
  const { data } = await api.post<FunctionalTestRead>(
    `/examinations/${examId}/functional-tests`,
    form,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return data;
}

export async function listFunctionalTests(examId: string): Promise<FunctionalTestRead[]> {
  const { data } = await api.get<FunctionalTestRead[]>(
    `/examinations/${examId}/functional-tests`,
  );
  return data;
}
